import React, { useEffect, useState } from "react"
import axios from "axios"
import { BASE_URL } from "../../Util/requests"
import Input from "../../Components/Input"
import InputMasked from "../../Components/InputMasked"
import Select from "../../Components/Select"
import Titulo from "../../Components/Titulo"
import LogoMultipla from "../../Images/logos/07824993000165.png"
import image_add from "../../Images/Buttons/add.png"
import image_clean from "../../Images/Buttons/clean.png"
import image_loading from "../../Images/spinner.gif";
import image_previous from "../../Images/Buttons/previous.png"
import image_save from "../../Images/Buttons/save.png"
import image_search from "../../Images/Buttons/search.png"

const ClientNew = ({jsonClient, setJsonClient, found, setFound, returnClientNew, height, width}) => {
  const [cpfCnpj, setCpfCnpj] = useState("")
  const [saleType, setSaleType] = useState(1)
  const [corporateName, setCorporateName] = useState("")
  const [fantasyName, setFantasyName] = useState("")
  const [responsibleCpf, setResponsibleCpf] = useState("")
  const [responsibleName, setResponsibleName] = useState("")
  const [ie, setIe] = useState("")
  const [indicatorIe, setIndicatorIe] = useState(3)
  const [im, setIm] = useState("")
  const [cnae, setCnae] = useState("")
  const [suframa, setSuframa] = useState("")

  const [emailNew, setEmailNew] = useState(true)
  const [optionsEmails, setOptionsEmails] = useState("{\"RESULT\": []}")
  const [emailCode, setEmailCode] = useState(0);
  const [emailCodeConfirm, setEmailCodeConfirm] = useState("");
  const [email, setEmail] = useState("")

  const [phoneNew, setPhoneNew] = useState(true)
  const [optionsPhone, setOptionsPhones] = useState("{\"RESULT\": []}")
  const [phoneCode, setPhoneCode] = useState(0);  
  const [phoneCodeConfirm, setPhoneCodeConfirm] = useState("");  
  const [phone, setPhone] = useState("")

  const [dueDay, setDueDay] = useState(1)
  const [dateBirth, setDateBirth] = useState("")
  const [regime, setRegime] = useState(1)
  const [regimeSpecial, setRegimeSpecial] = useState(1)
  const [password, setPassword] = useState("")
  const [passwordConfirm, setPasswordConfirm] = useState("")

  const [addressRelease, setAddressRelease] = useState(false)

  const [cep, setCep] = useState("")
  const [address, setAddress] = useState("")
  const [number, setNumber] = useState("")
  const [complement, setComplement] = useState("")
  const [neighborhood, setNeighborhood] = useState("")
  const [city, setCity] = useState("")
  const [cityIbge, setCityIbge] = useState("")
  const [uf, setUf] = useState("")
  const [ufIbge, setUfIbge] = useState("")
  const [countryCode, setCountryCode] = useState(0)
  const [countryDescription, setCountryDescription] = useState("BRASIL")
  const [countryIbge, setCountryIbge] = useState(1058)

  const [companyActivity, setCompanyActivity] = useState(2)
  const [companyAliquotCofins, setCompanyAliquotCofins] = useState(0)
  const [companyAliquotIss, setCompanyAliquotIss] = useState(0)
  const [companyAliquotPis, setCompanyAliquotPis] = useState(0) 
  const [companyAliquotSimples, setCompanyAliquotSimples] = useState(0) 
  const [companyCulture, setCompanyCulture] = useState(2) 
  const [companyProfile, setCompanyProfile] = useState(2) 

  const [firstAccess, setFirstAccess] = useState(true)
  const [updateFocu, setUpdateFocu] = useState(0)
  const [fieldSelected, setFieldSelected] = useState("")

  const [loading, setLoading] = useState("")
  const [warning, setWarning] = useState("")
  const [error, setError] = useState("")
    
  const [national, setNational] = useState(true)
  const [listCountry, setListCountry] = useState([])
  const [optionsCountries, setOptionsCountries] = useState("{\"RESULT\": [{\"ID\": 0, \"VALUE\": \"Selecione...\"}]}")

  const [newRecord, setNewRecord] = useState(true)
  const [emailValidation, setEmailValidation] = useState(false)
  const [phoneValidation, setPhoneValidation] = useState(false)
  const [databaseScreen, setDatabaseScreen] = useState(false)

  useEffect(() => {
    if (firstAccess){
      let returnJson = []

      setLoading("Aguarde buscando as informações...")
      setWarning("")
      setError("")
  
      let formData = new FormData()
      formData.append("DATABASE_TYPE", 2)
      formData.append("DATABASE_PATH", "User Id=postgres;Server=clmultipla-id43.cloudtsci.tec.br;Port=5432;Database=dbCentral;")
      formData.append("JSON_NEW_1", "{}")
      formData.append("JSON_LOGIN", "{ \"ID\": 1, \"COMPANY\": { \"ID\": 1 }, \"CPF\": \"79772468050\", \"PASSWORD\": \"M!LTPL\" }")
      formData.append("SYSTEM", true)
      formData.append("QUANTITY_INITIAL", 0)
      formData.append("QUANTITY_RECORDS", 252)
  
      axios.post(BASE_URL + "COUNTRY/Search", formData) 
      .then((response) => { returnJson = JSON.parse(response.data) })
      .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null"+
        ", \"WARNING\": null, \"ERROR\": \"Não foi possível pesquisar os países. ("+ response +")\"}") })
      .finally(() => {
        if (returnJson.SUCCESS === false){
          setError(returnJson.ERROR)
          setLoading("")
          return
        }
        else
        {
          let country = "{\"RESULT\": [{\"ID\": 0, \"VALUE\": \"Selecione...\"}"
  
          returnJson && returnJson.OBJECT &&
            returnJson.OBJECT.map(item => (
              country += ",{\"ID\": "+ item.ID +", \"VALUE\": \""+ item.NAME +"\"}"
            ))
  
          country += "]}"
  
          setListCountry(returnJson)
          setOptionsCountries(country)
          setCountryCode(34)
        }
      })

      setCpfCnpj(jsonClient.CPF_CNPJ)

      if (found){
        if (jsonClient.LstCLIENT_EMAIL.length !== 0){
          setEmailNew(false)

          let bEmailFound = false;
          let ltsEmail = "{\"RESULT\": ["

          for(let iC = 0; iC < jsonClient.LstCLIENT_EMAIL.length; iC++){
            if (iC !== 0) ltsEmail += ","

            ltsEmail += "{ \"ID\": "+ jsonClient.LstCLIENT_EMAIL[iC].ID +
              ", \"VALUE\": \""+ jsonClient.LstCLIENT_EMAIL[iC].EMAIL +"\" }"

            if (String(jsonClient.LstCLIENT_EMAIL[iC].STANDARD) == "1"){
              setEmailCode(jsonClient.LstCLIENT_EMAIL[iC].ID) 
              setEmail(jsonClient.LstCLIENT_EMAIL[iC].EMAIL)
              bEmailFound = true;
            }
          }
          
          ltsEmail += "]}"
          
          if (!bEmailFound){
            setEmailCode(jsonClient.LstCLIENT_EMAIL[0].ID)
            setEmail(jsonClient.LstCLIENT_EMAIL[0].EMAIL)
          }
            
          setOptionsEmails(ltsEmail)
        }

        if (jsonClient.LstCLIENT_PHONE.length !== 0){
          setPhoneNew(false)

          let bPhoneFound = false;
          let ltsPhone = "{\"RESULT\": ["

          for(let iC = 0; iC < jsonClient.LstCLIENT_PHONE.length; iC++){
            if (iC !== 0) ltsPhone += ","

            ltsPhone += "{ \"ID\": "+ jsonClient.LstCLIENT_PHONE[iC].ID +
              ", \"VALUE\": \""+ jsonClient.LstCLIENT_PHONE[iC].NUMBER +"\" }"

            if (String(jsonClient.LstCLIENT_PHONE[iC].STANDARD) == "1"){
              setPhoneCode(jsonClient.LstCLIENT_PHONE[iC].ID) 
              setPhone(jsonClient.LstCLIENT_PHONE[iC].NUMBER) 
              bPhoneFound = true;
            }
          }
          
          ltsPhone += "]}"
          
          if (!bPhoneFound){
            setPhoneCode(jsonClient.LstCLIENT_PHONE[0].ID)
            setPhone(jsonClient.LstCLIENT_PHONE[0].NUMBER) 
          }

          setOptionsPhones(ltsPhone)
        }

        setAddress(jsonClient.ADDRESS)
        setCep(jsonClient.CEP)
        setCity(jsonClient.CITY)
        setCityIbge(jsonClient.CITY_IBGE)

        if ((jsonClient.COMPLEMENT !== null) && (jsonClient.COMPLEMENT !== "")) setComplement(jsonClient.COMPLEMENT)

        setCorporateName(jsonClient.CORPORATE_NAME)

        if ((jsonClient.FANTASY_NAME !== null) && (jsonClient.FANTASY_NAME !== "")) setFantasyName(jsonClient.FANTASY_NAME)
          else setFantasyName(jsonClient.CORPORATE_NAME)

        setCountryDescription(jsonClient.COUNTRY_DESCRIPTION)
        setCountryIbge(jsonClient.COUNTRY_IBGE)
        setNeighborhood(jsonClient.NEIGHBORHOOD)
        setNumber(jsonClient.NUMBER)
        setUf(jsonClient.UF)
        setUfIbge(jsonClient.UF_IBGE)

        if ((jsonClient.RESPONSIBLE_CPF !== null) && (jsonClient.RESPONSIBLE_CPF !== "")) 
          setResponsibleCpf(jsonClient.RESPONSIBLE_CPF)

        if ((jsonClient.RESPONSIBLE_NAME !== null) && (jsonClient.RESPONSIBLE_NAME !== "")) 
          setResponsibleName(jsonClient.RESPONSIBLE_NAME)

        if (jsonClient.COMPANY_SGE == null){
          if ((jsonClient.CNAE !== null) && (jsonClient.CNAE !== 0)) setCnae(jsonClient.CNAE)          

          setIe(jsonClient.IE)
          setIndicatorIe(jsonClient.INDICATOR_IE)
        }
        else{          
          setCompanyActivity(jsonClient.COMPANY_SGE.ACTIVITY)
          setCompanyAliquotCofins(jsonClient.COMPANY_SGE.ALIQUOT_COFINS)
          setCompanyAliquotIss(jsonClient.COMPANY_SGE.ALIQUOT_ISS)
          setCompanyAliquotPis(jsonClient.COMPANY_SGE.ALIQUOT_PIS)
          setCompanyAliquotSimples(jsonClient.COMPANY_SGE.ALIQUOT_SIMPLES)
          setCompanyCulture(jsonClient.COMPANY_SGE.CULTURE)
          setCompanyProfile(jsonClient.COMPANY_SGE.PROFILE)

          if ((jsonClient.COMPANY_SGE.CNAE !== null) && (jsonClient.COMPANY_SGE.CNAE !== 0)) setCnae(jsonClient.COMPANY_SGE.CNAE)

          setIe(jsonClient.COMPANY_SGE.IE)
          setRegime(jsonClient.COMPANY_SGE.REGIME)
          setRegimeSpecial(jsonClient.COMPANY_SGE.REGIME_SPECIAL)
        }
      }

      setFirstAccess(false)
      setLoading("")
    }
    else{
      if (found){        
        if ((jsonClient.CNAE !== null) && (jsonClient.CNAE !== 0)) setCnae(jsonClient.CNAE)

        setCorporateName(jsonClient.CORPORATE_NAME)
        setCountryIbge(1058)

        if ((jsonClient.DATE_BIRTH !== null) && (jsonClient.DATE_BIRTH !== "")) setDateBirth(jsonClient.DATE_BIRTH)

        if (jsonClient.DUE_DAY == 10) setDueDay(2)
        else if (jsonClient.DUE_DAY == 20) setDueDay(3)
        else setDueDay(1)

        if ((jsonClient.FANTASY_NAME !== null) && (jsonClient.FANTASY_NAME !== "")) setFantasyName(jsonClient.FANTASY_NAME)
        else setFantasyName(jsonClient.CORPORATE_NAME)

        if ((jsonClient.STANDARD_EMAIL !== null) && (jsonClient.STANDARD_EMAIL !== "")) setEmail(jsonClient.STANDARD_EMAIL)

        setIe(jsonClient.IE)
        setIndicatorIe(jsonClient.INDICATOR_IE)        

        if ((jsonClient.STANDARD_PHONE !== null) && (jsonClient.STANDARD_PHONE !== "")) setPhone(jsonClient.STANDARD_PHONE)
        if ((jsonClient.IM !== null) && (jsonClient.IM !== "")) setIm(jsonClient.IM)

        setRegime(jsonClient.REGIME)
        setRegimeSpecial(jsonClient.REGIME_SPECIAL)

        if ((jsonClient.RESPONSIBLE_CPF !== null) && (jsonClient.RESPONSIBLE_CPF !== "")) 
          setResponsibleCpf(jsonClient.RESPONSIBLE_CPF)

        if ((jsonClient.RESPONSIBLE_NAME !== null) && (jsonClient.RESPONSIBLE_NAME !== "")) 
          setResponsibleName(jsonClient.RESPONSIBLE_NAME)

        setSaleType(jsonClient.SALE_TYPE)

        if ((jsonClient.SUFRAMA !== null) && (jsonClient.RESPONSIBLE_NAME !== "")) 
          setSuframa(jsonClient.SUFRAMA)

        if (jsonClient.COUNTRY_DESCRIPTION !== countryDescription){
          (countryDescription === "BRASIL") ? setNational(true) : setNational(false)

          setCep("")
          setAddress("")
          setNumber("")
          setComplement("")
          setNeighborhood("")
          setCity("")
          setCityIbge("")
          setUf("")
          setUfIbge("")          
        }
        else{
          (countryDescription === "BRASIL") ? setNational(true) : setNational(false)
          
          setCep(jsonClient.CEP)
          setAddress(jsonClient.ADDRESS)
          setNumber(jsonClient.NUMBER)

          if ((jsonClient.COMPLEMENT !== null) && (jsonClient.COMPLEMENT !== "")) setComplement(jsonClient.COMPLEMENT)

          setNeighborhood(jsonClient.NEIGHBORHOOD)
          setCity(jsonClient.CITY)
          setCityIbge(jsonClient.CITY_IBGE)
          setUf(jsonClient.UF)
          setUfIbge(jsonClient.UF_IBGE)
          setCountryDescription(jsonClient.COUNTRY_DESCRIPTION)
          setCountryIbge(jsonClient.COUNTRY_IBGE)
        }
      }
      else{
        (countryDescription === "BRASIL") ? setNational(true) : setNational(false)

        setCep("")
        setAddress("")
        setNumber("")
        setComplement("")
        setNeighborhood("")
        setCity("")
        setCityIbge("")
        setUf("")
        setUfIbge("")
      }

      document.getElementById("clientNewCorporateName") && document.getElementById("clientNewCorporateName").focus()
    }
  }, [firstAccess, countryDescription, listCountry.OBJECT, jsonClient])

  const clearAddress = () => {
    setCep("")
    setAddress("")
    setNumber("")
    setComplement("")
    setNeighborhood("")
    setCity("")
    setCityIbge("")
    setUf("")
    setUfIbge("")

    setAddressRelease(false)
  }

  const isNullOrEmpty = (str) => {
    if (str === null || str === '') {
      return true;
    }
    return false;
  }

  const newEmail = () => {    
    setEmailNew(true)
    setOptionsEmails("{\"RESULT\": []}")
    setEmailCode(0);

    setEmail("")    
    document.getElementById("clientNewEmail") && document.getElementById("clientNewEmail").focus()
  }

  const newPhone = () => {    
    setPhoneNew(true)
    setOptionsPhones("{\"RESULT\": []}")
    setPhoneCode(0);

    setPhone("")    
    document.getElementById("clientNewPhone") && document.getElementById("clientNewPhone").focus()
  }

  const saveClient = () => {
    let returnJson = []

    setLoading("Aguarde, inserindo seus dados na base de dados...")
    setWarning("")
    setError("")

    if (!validation()){
      setLoading("")
      return
    } 

    let jsonClient_New = "{ \"CPF_CNPJ\": \""+ cpfCnpj +"\""+
      ", \"CORPORATE_NAME\": \""+ corporateName +"\""+
      ", \"FANTASY_NAME\": \""+ fantasyName +"\""+
      ", \"CEP\": \""+ cep +"\""+
      ", \"ADDRESS\": \""+ address +"\""+
      ", \"NUMBER\": \""+ number +"\""+
      ", \"NEIGHBORHOOD\": \""+ neighborhood +"\""+
      ", \"CITY\": \""+ city +"\""+
      ", \"CITY_IBGE\": "+ cityIbge +
      ", \"UF\": \""+ uf +"\""+
      ", \"UF_IBGE\": "+ ufIbge +
      ", \"COUNTRY_DESCRIPTION\": \""+ countryDescription +"\""+
      ", \"COUNTRY_IBGE\": "+ countryIbge +
      ", \"RESPONSIBLE_CPF\": \""+ responsibleCpf +"\""+
      ", \"RESPONSIBLE_NAME\": \""+ responsibleName +"\""+      
      ", \"SYSTEM_TYPE\": 2"+
      ", \"SALE_TYPE\": "+ saleType +
      ", \"INDICATOR_IE\": "+ indicatorIe +
      ", \"ESTABLISHMENT\": { \"ID\": 1, \"DESCRIPTION\": \"PADARIA\" }"+
      ", \"CLIENT_CLASS\": { \"ID\": 1, \"DESCRIPTION\": \"SERVIDOR 1707877 59 SEM PDV\" }"+
      ", \"CLIENT_TYPE\": { \"ID\": 5, \"DESCRIPTION\": \"AVULSO\" }"+
      ", \"BAR_CODE\": \""+ cpfCnpj +"\""+
      ", \"PASSWORD\": \""+ password +"\""+
      ", \"SHIPPING_TYPE\": 1"+
      ", \"TYPE\": 2"+
      ", \"BANK_TYPE\": 2"+      
      ", \"TYPE_TRANSFER\": 3"+
      ", \"VALUE_TRANSFER\": 1"+      
      ", \"STANDARD_EMAIL\": \""+ email +"\""+
      ", \"STANDARD_PHONE\": \""+ phone +"\""+
      ", \"CLIENT_COMPANY\": { \"COMPANY\": { \"ID\": 1 } }"+
      ", \"SITUATION\": 1"      
    
    if ((jsonClient.ID !== undefined) && (jsonClient.ID !== 0)) jsonClient_New += ", \"ID\": "+ jsonClient.ID
    if (!isNullOrEmpty(ie)) jsonClient_New += ", \"IE\": \""+ ie +"\""; else jsonClient_New += ", \"IE\": \"ISENTO\""
    if (!isNullOrEmpty(im)) jsonClient_New += ", \"IM\": \""+ im +"\""
    if (!isNullOrEmpty(cnae)) jsonClient_New += ", \"CNAE\": \""+ cnae +"\""
    if (!isNullOrEmpty(suframa)) jsonClient_New += ", \"SUFRAMA\": \""+ suframa +"\""

    if (dueDay === 1) jsonClient_New += ", \"DUE_DAY\": "+ 1
    else if (dueDay === 2) jsonClient_New += ", \"DUE_DAY\": "+ 10
    else if (dueDay === 3) jsonClient_New += ", \"DUE_DAY\": "+ 20

    if (!isNullOrEmpty(dateBirth)){
      if (validateDate(dateBirth)) jsonClient_New += ", \"DATE_BIRTH\": \""+ dateBirth +"\""
    }

    if (!isNullOrEmpty(complement)) jsonClient_New += ", \"COMPLEMENT\": \""+ complement +"\""

    if ((jsonClient.CLIENT !== undefined) && (jsonClient.CLIENT !== null))
    {
      if (!isNullOrEmpty(jsonClient.CLIENT.INTEGRATE_SGE)){
        if (jsonClient.CLIENT.INTEGRATE_SGE === "1"){
          jsonClient_New += ", \"INTEGRATE_SGE\": \""+ jsonClient.CLIENT.INTEGRATE_SGE +"\""+
            ", \"DOMAIN_SGE\": \""+ jsonClient.CLIENT.DOMAIN_SGE +"\""+
            ", \"DATABASE_SGE\": \""+ jsonClient.CLIENT.DATABASE_SGE +"\""
        }
      }
    }

    jsonClient_New += " }"

    let formData = new FormData()
    formData.append("JSON_OLD", JSON.stringify(jsonClient))    
    formData.append("JSON_NEW_1", jsonClient_New)

    axios.post(BASE_URL + "CLIENT/New", formData) 
    .then((response) => { returnJson = JSON.parse(response.data) })
    .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null"+
      ", \"WARNING\": null, \"ERROR\": \"Não foi possível incluir o cliente. ("+ response +")\"}") })
    .finally(() => {
      if (returnJson.SUCCESS === false){
        setError(returnJson.ERROR)
        setLoading("")
        return
      }
      else
      {
        setFound(true)
        setJsonClient(returnJson.OBJECT)
        setNewRecord(false)

        if (String(returnJson.OBJECT.CONFIRM_EMAIL) == "1"){
          if (String(returnJson.OBJECT.CONFIRM_PHONE) == "1") setDatabaseScreen(true)            
          else setPhoneValidation(true)
        } else setEmailValidation(true)

        setLoading("")
      }
    })

    /*
    let jsonCompany_New = "{ \"CPF_CNPJ\": \""+ cpfCnpj +"\""+
      ", \"CORPORATE_NAME\": \""+ corporateName +"\""+
      ", \"FANTASY_NAME\": \""+ fantasyName +"\""+
      ", \"CEP\": \""+ cep +"\""+
      ", \"ADDRESS\": \""+ address +"\""+
      ", \"NUMBER\": \""+ number +"\""+
      ", \"NEIGHBORHOOD\": \""+ neighborhood +"\""+
      ", \"CITY\": \""+ city +"\""+
      ", \"CITY_IBGE\": "+ cityIbge +
      ", \"UF\": \""+ uf +"\""+
      ", \"UF_IBGE\": "+ ufIbge +
      ", \"COUNTRY_DESCRIPTION\": \""+ countryDescription +"\""+
      ", \"COUNTRY_IBGE\": "+ countryIbge +
      ", \"RESPONSIBLE_CPF\": \""+ responsibleCpf +"\""+
      ", \"RESPONSIBLE_NAME\": \""+ responsibleName +"\""+
      ", \"REGIME\": "+ regime +
      ", \"REGIME_SPECIAL\": "+ regimeSpecial +
      ", \"ESTABLISHMENT\": { \"ID\": 1 }"+
      ", \"SPECIES\": 1"+
      ", \"IDENTIFICATION_AGREEMENT\": 1"+
      ", \"IDENTIFICATION_NATURE\": 3"+
      ", \"IDENTIFICATION_FINALITY\": 1"+
      ", \"PROFILE\": "+ companyProfile +
      ", \"ACTIVITY\": "+ companyActivity +
      ", \"CULTURE\": "+ companyCulture +
      ", \"ENVIRONMENT\": 1"+
      ", \"EMISSION_TYPE\": 1"+
      ", \"SALE_TYPE\": 1"+
      ", \"ALIQUOT_COFINS\": "+ companyAliquotCofins +
      ", \"ALIQUOT_ISS\": "+ companyAliquotIss +
      ", \"ALIQUOT_PIS\": "+ companyAliquotPis +
      ", \"ALIQUOT_SIMPLES\": "+ companyAliquotSimples +      
      ", \"STANDARD_EMAIL\": \""+ email +"\""+
      ", \"STANDARD_PHONE\": \""+ phone +"\""

    if (!isNullOrEmpty(ie)) jsonCompany_New += ", \"IE\": \""+ ie +"\""; else jsonClient_New += ", \"IE\": \"ISENTO\""
    if (!isNullOrEmpty(im)) jsonCompany_New += ", \"IM\": \""+ im +"\""
    if (!isNullOrEmpty(cnae)) jsonCompany_New += ", \"CNAE\": \""+ cnae +"\""
    if (!isNullOrEmpty(suframa)) jsonCompany_New += ", \"SUFRAMA\": \""+ suframa +"\""
    if (!isNullOrEmpty(ie) === "") jsonCompany_New += ", \"SEND_NFE\": "+ 1; else jsonCompany_New += ", \"SEND_NFE\": "+ 2
    if (!isNullOrEmpty(ie) === "") jsonCompany_New += ", \"SEND_NFCE\": "+ 1; else jsonCompany_New += ", \"SEND_NFCE\": "+ 2

    if ((!isNullOrEmpty(im) === "") && (!isNullOrEmpty(cnae) === "")) jsonCompany_New += ", \"SEND_NFSE\": "+ 1
    else jsonCompany_New += ", \"SEND_NFSE\": "+ 2

    if (!isNullOrEmpty(complement)) jsonClient_New += ", \"COMPLEMENT\": \""+ complement +"\""
  
    if (jsonClient.COMPANY_SGE !== null){
      if (!isNullOrEmpty(jsonClient.COMPANY_SGE.DATABASE_SGE)) jsonCompany_New += ", \"DATABASE_SGE\": "+ jsonClient.COMPANY_SGE.DATABASE_SGE
      if (!isNullOrEmpty(jsonClient.COMPANY_SGE.DOMAIN_SGE)) jsonCompany_New += ", \"DOMAIN_SGE\": "+ jsonClient.COMPANY_SGE.DOMAIN_SGE
    }

    jsonCompany_New += " }"
    */
  }

  const resendEmail = () => {
    let returnJson = []

    setLoading("Aguarde enviando o código de confirmação para o seu Email...")
    setWarning("")
    setError("")

    const formData = new FormData()
    formData.append("JSON_NEW_1", "{}")

    axios.put(BASE_URL + "CLIENT/UpdateEmailCode", formData)
    .then((response) => { returnJson = JSON.parse(response.data) })
    .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null"+
      ", \"WARNING\": null, \"ERROR\": \"Não foi possível enviar o código de confirmação para o seu Email. ("+ response +")\"}") })
    .finally(() => {
      if (returnJson.SUCCESS === false){
        setError(returnJson.ERROR)
        setLoading("")
        document.getElementById("clientNewEmailCode") && document.getElementById("clientNewEmailCode").focus()
        return
      }

      setWarning("Re-Envio efetuado com sucesso!")
      setLoading("")

      setEmailCode("")
      document.getElementById("clientNewEmailCode") && document.getElementById("clientNewEmailCode").focus()
    })
  }

  const resendPhone = () => {
    let returnJson = []

    setLoading("Aguarde enviando o código de confirmação para o seu WhatsApp...")
    setWarning("")
    setError("")

    const formData = new FormData()
    formData.append("JSON_NEW_1", "{}")

    axios.put(BASE_URL + "CLIENT/UpdateEmailCode", formData)
    .then((response) => { returnJson = JSON.parse(response.data) })
    .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null"+
      ", \"WARNING\": null, \"ERROR\": \"Não foi possível enviar o código de confirmação para o seu WhatsApp. ("+ response +")\"}") })
    .finally(() => {
      if (returnJson.SUCCESS === false){
        setError(returnJson.ERROR)
        setLoading("")
        document.getElementById("clientNewPhoneCode") && document.getElementById("clientNewPhoneCode").focus()
        return
      }

      setWarning("Re-Envio efetuado com sucesso!")
      setLoading("")

      setPhoneCode("")
      document.getElementById("clientNewPhoneCode") && document.getElementById("clientNewPhoneCode").focus()
    })    
  }

  const returnEmail = () => {
    setEmailCode("")

    setEmailValidation(false)
    setNewRecord(true)
  }

  const returnPhone = () => {
    setPhoneCode("")

    setPhoneValidation(false)
    setEmailValidation(true)
  }  

  const searchCEP = () => {
    if (cep === "")
    {
      setLoading("")
      setWarning("")
      setError("É necessário informar o CEP.")

      return
    }

    setLoading("Aguarde buscando o CEP...")

    const apiCEP = axios.create({
      baseURL: "https://viacep.com.br/ws/"
    })

    apiCEP.get(cep + "/json/")
    .then((response) => {
      if (response.data.erro !== "true") {
        setWarning("")
        setError("")

        if ((response.data.logradouro === '') && (response.data.bairro === '')) setAddressRelease(true)
        else setAddressRelease(false)

        setAddress(response.data.logradouro)
        setNeighborhood(response.data.bairro)
        setCity(response.data.localidade)
        setCityIbge(response.data.ibge)
        setUf(response.data.uf)

        if (response.data.uf === "RO") setUfIbge(11)
        if (response.data.uf === "AC") setUfIbge(12)
        if (response.data.uf === "AM") setUfIbge(13)
        if (response.data.uf === "RR") setUfIbge(14)
        if (response.data.uf === "PA") setUfIbge(15)
        if (response.data.uf === "AP") setUfIbge(16)
        if (response.data.uf === "TO") setUfIbge(17)
        if (response.data.uf === "MA") setUfIbge(21)
        if (response.data.uf === "PI") setUfIbge(22)
        if (response.data.uf === "CE") setUfIbge(23)
        if (response.data.uf === "RN") setUfIbge(24)
        if (response.data.uf === "PB") setUfIbge(25)
        if (response.data.uf === "PE") setUfIbge(26)
        if (response.data.uf === "AL") setUfIbge(27)
        if (response.data.uf === "SE") setUfIbge(28)
        if (response.data.uf === "BA") setUfIbge(29)
        if (response.data.uf === "MG") setUfIbge(31)
        if (response.data.uf === "ES") setUfIbge(32)
        if (response.data.uf === "RJ") setUfIbge(33)
        if (response.data.uf === "SP") setUfIbge(35)
        if (response.data.uf === "PR") setUfIbge(41)
        if (response.data.uf === "SC") setUfIbge(42)
        if (response.data.uf === "RS") setUfIbge(43)
        if (response.data.uf === "MS") setUfIbge(50)
        if (response.data.uf === "MT") setUfIbge(51)
        if (response.data.uf === "GO") setUfIbge(52)
        if (response.data.uf === "DF") setUfIbge(53)
      } 
      else
      {
        setWarning("")
        setError("CEP não encontrado.")
        alert("CEP não encontrado.")

        setAddress("")
        setNeighborhood("")
        setCity("")
        setCityIbge("")
        setUf("")
        setUfIbge("")
      }
    })
    .catch(() => {
      setWarning("")
      setError("Não foi possível obter CEP.")
      alert("Não foi possível obter CEP.")
    }) 
    .finally(() => { setLoading("") })
  }

  const selectCountry = (event) => {
    let itemP = {}
    listCountry.OBJECT.map(item => (
      (item.ID ===  parseInt(event)) ? itemP = item : ""
    ))

    setCountryCode(itemP.ID)
    setCountryIbge(itemP.IBGE)
    setCountryDescription(itemP.NAME)
  }

  const selectEmail = (event) => {
    let itemE = {}

    jsonClient.LstCLIENT_EMAIL.map(item => (
      (item.ID ===  parseInt(event)) ? itemE = item : ""
    ))

    setEmailCode(itemE.ID)
    setEmail(itemE.EMAIL)
  }

  const selectPhone = (event) => {
    let itemP = {}
    jsonClient.LstCLIENT_PHONE.map(item => (
      (item.ID ===  parseInt(event)) ? itemP = item : ""
    ))

    setPhoneCode(itemP.ID)
    setPhone(itemP.NUMBER)
  }

  const validateDate = (value) => {
    let error = false;
    const date = value;
    let ardt = new Array([]);
    const ExpReg = new RegExp("(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[012])/[12][0-9]{3}");
    ardt = date.split("/");

    if (date.search(ExpReg) === -1) error = true
    else if (((ardt[1]===4)||(ardt[1]===6)||(ardt[1]===9)||(ardt[1]===11))&&(ardt[0]>30)) error = true
    else if (ardt[1]===2) {
      if ((ardt[0]>28)&&((ardt[2]%4)!==0)) error = true;
      if ((ardt[0]>29)&&((ardt[2]%4)===0)) error = true;
    }

    if (error) return false;
    return true;
  }

  const validation = () => {
    if (jsonClient.CPF_CNPJ.length == 11){
      if (isNullOrEmpty(corporateName))
      {
        setError("É necessário informar o Nome!")
        document.getElementById("clientNewPhoneCode") && document.getElementById("clientNewCorporateName").focus()
        return false
      } else setFantasyName(corporateName)

      setResponsibleCpf(cpfCnpj)
      setResponsibleName(corporateName)
    } 
    else if (jsonClient.CPF_CNPJ.length == 14)
    {
      if (isNullOrEmpty(corporateName))
      {
        setError("É necessário informar a Razão Social!")
        document.getElementById("clientNewCorporateName") && document.getElementById("clientNewCorporateName").focus()
        return false
      }

      if (isNullOrEmpty(fantasyName))
      {
        setError("É necessário informar o nome Fantasia!")
        document.getElementById("clientNewFantasyName") && document.getElementById("clientNewFantasyName").focus()
        return false
      }

      if (isNullOrEmpty(responsibleCpf))
      {
        setError("É necessário informar o CPF do Reponsável!")
        document.getElementById("clientNewResponsibleCpf") && document.getElementById("clientNewResponsibleCpf").focus()
        return false
      }
      
      if (isNullOrEmpty(responsibleName))
      {
        setError("É necessário informar o Nome do Reponsável!")
        document.getElementById("clientNewResponsibleName") && document.getElementById("clientNewResponsibleName").focus()
        return false
      }      
    }

    if (isNullOrEmpty(email))
    {
      setError("É necessário informar o email!")
      document.getElementById("clientNewEmail") && document.getElementById("clientNewEmail").focus()
      return false
    }

    if (isNullOrEmpty(phone))
    {
      setError("É necessário informar o número do telefone!")
      document.getElementById("clientNewPhone") && document.getElementById("clientNewPhone").focus()
      return false
    }    

    if (isNullOrEmpty(password))
    {
      setError("É necessário informar a senha!")
      document.getElementById("clientNewPassword") && document.getElementById("clientNewPassword").focus()
      return false
    }

    if (isNullOrEmpty(passwordConfirm))
    {
      setError("É necessário informar a confirmação da senha!")
      document.getElementById("clientNewPasswordConfirm") && document.getElementById("clientNewPasswordConfirm").focus()
      return false
    }

    if (password !== passwordConfirm)
    {
      setError("A senha não confere com a confirmação da senha!")
      document.getElementById("clientNewPassword") && document.getElementById("clientNewPassword").focus()
      return false
    }

    if (isNullOrEmpty(cep))
    {
      setError("É necessário informar o CEP!")
      document.getElementById("clientNewCep") && document.getElementById("clientNewCep").focus()
      return false
    }

    if (isNullOrEmpty(address))
    {
      setError("É necessário informar o Endereço!")
      document.getElementById("clientNewAddress") && document.getElementById("clientNewAddress").focus()
      return false
    }

    if (isNullOrEmpty(number))
    {
      setError("É necessário informar o Número!")
      document.getElementById("clientNewNumber") && document.getElementById("clientNewNumber").focus()
      return false
    }

    if (isNullOrEmpty(neighborhood))
    {
      setError("É necessário informar o Bairro!")
      document.getElementById("clientNewNeighborhood") && document.getElementById("clientNewNeighborhood").focus()
      return false
    }

    if (isNullOrEmpty(city))
    {
      setError("É necessário informar a Cidade!")
      document.getElementById("clientNewCity") && document.getElementById("clientNewCity").focus()
      return false
    }

    if (isNullOrEmpty(uf))
    {
      setError("É necessário informar o Estado!")
      document.getElementById("clientNewUf") && document.getElementById("clientNewUf").focus()
      return false
    }

    if (isNullOrEmpty(countryDescription))
    {
      setError("É necessário informar o País!")
      document.getElementById("clientNewCountryDescription") && document.getElementById("clientNewCountryDescription").focus()
      return false
    }

    return true
  }

  const validationEmail = () => {
    let returnJson = []

    setLoading("Aguarde verificando o código do Email...")
    setWarning("")
    setError("")

    const formData = new FormData()
    formData.append("JSON_NEW_1", "{ \"ID\": "+ jsonClient.ID +", \"CONFIRM_CODE\": \""+ emailCode +"\" }")

    axios.post(BASE_URL + "CLIENT/CheckEmailCode", formData)
    .then((response) => { returnJson = JSON.parse(response.data) })
    .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null"+
      ", \"WARNING\": null, \"ERROR\": \"Não foi possível verificar o código do Email. ("+ response +")\"}") })
    .finally(() => {
      if (returnJson.SUCCESS === false){
        setError(returnJson.ERROR)
        setLoading("")
        document.getElementById("clientNewEmailCode") && document.getElementById("clientNewEmailCode").focus()
        return
      }

      setEmailValidation(false)
      setPhoneValidation(true)
      document.getElementById("clientNewPhoneCode") && document.getElementById("clientNewPhoneCode").focus()
    })
  }

  const validationPhone = () => {
    let returnJson = []
    
    setLoading("Aguarde verificando o código do WhatsApp...")
    setWarning("")
    setError("")

    const formData = new FormData()
    formData.append("JSON_NEW_1", "{ \"ID\": "+ jsonClient.ID +", \"CONFIRM_CODE\": \""+ emailCode +"\" }")

    axios.post(BASE_URL + "CLIENT/CheckPhoneCode", formData)
    .then((response) => { returnJson = JSON.parse(response.data) })
    .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null"+
      ", \"WARNING\": null, \"ERROR\": \"Não foi possível verificar o código do WhatsApp. ("+ response +")\"}") })
    .finally(() => {
      if (returnJson.SUCCESS === false){
        setError(returnJson.ERROR)
        setLoading("")
        document.getElementById("clientNewPhoneCode") && document.getElementById("clientNewPhoneCode").focus()
        return
      }

      setPhoneValidation(false)

      //axios.post(BASE_URL + "CLIENT/CheckPhoneCode", formData)
      //.then((response) => { returnJson = JSON.parse(response.data) })

      setDatabaseScreen(true)
    })
  }  

  return(
    <div style={{display: "flex", flexGrow: 1, flexDirection: "column", minHeight: height}}>
      <div style={{display: "flex", flexGrow: 0, flexDirection: "column"}}>
        <div style={{backgroundColor: "rgb(128, 130, 133)", height: 20}} />
        <div style={{display: "flex", flexGrow: 0, height: 3, backgroundColor: "white"}} />                  
        <div style={{display: "flex", flexGrow: 0, height: 6, backgroundColor: "rgb(0, 177, 171)"}} />
      </div>
        
      <div style={{display: "flex", justifyContent: "center", marginBottom: 5}}>
        <img src={LogoMultipla} alt="Logomarca" />
      </div>

      { loading ?
          <div style={{display: "flex", flexDirection: "column", flexGrow: 1, justifyContent: "center", alignItems: "center"}}>
            <img style={{marginBottom: 10, height: 32, width: 32}} src={image_loading} alt="Carregando"/>
            <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>{loading}</label>
          </div>
        :
          <>

            { newRecord &&
              <>
                { (jsonClient.CPF_CNPJ.length == 11) ?
                  <div style={(width < 450) ? {display: "flex", flexDirection: "column", paddingLeft: 10, paddingRight: 10}
                    : {display: "flex", flexDirection: "column", paddingLeft: 20, paddingRight: 20}}>
                    <div style={{display: "flex", justifyContent: "center", marginBottom: 5}}>
                      <label style={{fontWeight: 600, textAlign: "center"}}>Informe os dados pessoais:</label>
                    </div>

                    <div style={(width < 580) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 10}
                      : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 10}}>
                      <div style={(width < 580) ? {display: "flex", flexGrow: 1, minWidth: 190}
                        : {display: "flex", flexGrow: 0, minWidth: 190, maxWidth: 190}}>
                        <Input
                          type="text"
                          name="clientNewCpfCnpj"
                          description="CPF"
                          value={cpfCnpj}
                          maxLength={14}
                          disabled={true}
                          require={true}
                          image={false}
                          typeInput={2}
                          onSelect={setFieldSelected}
                          onChange={(event) => setCpfCnpj(event.target.value)} />
                      </div>
                      <div style={(width < 580) ? {display: "flex", flexGrow: 1, marginTop: 10, minWidth: 180}
                        : {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}}>
                        <Input
                          type="text"
                          name="clientNewCorporateName"
                          description="Nome"
                          value={corporateName}
                          maxLength={60}
                          disabled={false}
                          require={true}
                          image={false}
                          typeInput={2}
                          onSelect={setFieldSelected}
                          onChange={(event) => setCorporateName(event.target.value)} />
                      </div>
                    </div>

                    <div style={(width < 910) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 5}
                      : {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 5}}>
                      <div style={(width < 520) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                        : {display: "flex", flexDirection: "row", flexGrow: 1}}>
                        <div style={(width < 520) ? {display: "flex", flexGrow: 1, minWidth: 180}
                          : {display: "flex", flexGrow: 0, minWidth: 190, maxWidth: 190}}>
                          <InputMasked
                            type="text"
                            name="clientNewIe"
                            description="IE"
                            mask="99999999999999"
                            value={ie}
                            disabled={false}
                            require={false}
                            image={false}
                            typeImage={0}
                            typeInput={2}
                            onSelect={setFieldSelected}
                            onChange={(event) => setIe(event.target.value)} />
                        </div>
                        <div style={(width < 520) ? {display: "flex", flexGrow: 1, marginTop: 5, minWidth: 180}
                          : {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 280}}>
                          <Select
                            name="clientNewIndicatorIe"
                            description="Indicador IE"
                            value={indicatorIe || 3}
                            disabled={false}
                            require={true}
                            options={JSON.parse("{ \"RESULT\": [{\"ID\": 1, \"VALUE\": \"Contribuinte do ICMS\" }"+
                              ", {\"ID\": 2, \"VALUE\": \"Contribuinte Isento de ICMS\" }"+
                              ", {\"ID\": 3, \"VALUE\": \"Não Contribuinte do ICMS\" }] }")}
                            image={false}
                            typeImage={0}
                            typeInput={2}
                            onSelect={setFieldSelected}
                            set={setIndicatorIe} />
                          </div>
                        </div>

                        <div style={(width < 410) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 5}
                          : (width < 910) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 5}
                          : {display: "flex", flexDirection: "row", flexGrow: 0, marginLeft: 10}}>
                          <div style={(width < 410) ? {display: "flex", flexGrow: 1, minWidth: 180}
                            : (width < 910) ? {display: "flex", flexGrow: 1, minWidth: 200}
                            : {display: "flex", flexGrow: 0, minWidth: 200, maxWidth: 200}}>
                            <Input
                              type="text"
                              name="clientNewIm"
                              description="IM"
                              value={im}
                              maxLength={15}
                              disabled={false}
                              require={false}
                              image={false}
                              typeImage={0}
                              typeInput={2}
                              onSelect={setFieldSelected}
                              onChange={(event) => setIm(event.target.value)} />
                          </div>
                          <div style={(width < 410) ? {display: "flex", flexGrow: 1, marginTop: 5, minWidth: 180}
                            : (width < 910) ? {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 150}
                            : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 150, maxWidth: 150}}>
                            <Input
                              type="text"
                              name="clientNewCnae"
                              description="CNAE"
                              value={cnae}
                              maxLength={9}
                              disabled={false}
                              require={false}
                              image={false}
                              typeInput={2}
                              onSelect={setFieldSelected}
                              onChange={(event) => setCnae(event.target.value)} />
                          </div>
                        </div>
                      </div>

                      <div style={(width < 910) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 5}
                        : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 5}}>

                        <div style={(width < 890) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                          : {display: "flex", flexDirection: "row", flexGrow: 1}}>

                          { emailNew ?
                              <div style={{display: "flex", flexGrow: 1, minWidth: 180}}>
                                <Input
                                  type="text"
                                  name="clientNewEmail"
                                  description="Email"
                                  value={email}
                                  maxLength={70}
                                  disabled={false}
                                  require={true}
                                  image={false}
                                  typeInput={2}
                                  onSelect={setFieldSelected}
                                  onChange={(event) => setEmail(event.target.value)} />
                              </div>
                            :
                              <div style={(width < 510) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                : {display: "flex", flexDirection: "row", flexGrow: 1}}>
                                <div style={{display: "flex", flexGrow: 1}}>
                                  <Select
                                    name="clientNewEmailCode"
                                    description="Selecione o Email"
                                    value={emailCode}
                                    disabled={false}
                                    require={false}
                                    options={JSON.parse(optionsEmails)}
                                    image={false}
                                    typeImage={0}
                                    typeInput={2}
                                    onSelect={setFieldSelected}
                                    set={selectEmail} 
                                  />
                                </div>                                
                                <div style={(width < 510) ? {display: "flex", flexGrow: 1, justifyContent: "center", marginTop: 5}
                                  : {display: "flex", flexGrow: 0, marginLeft: 10}}>
                                  <img
                                    style={{height: 42, width: 42}}
                                    name="clientNewEmailNew"
                                    src={image_add} 
                                    alt="Novo" 
                                    onClick={() => newEmail()} />                                  
                                </div>
                              </div>
                          }

                          <div style={(width < 890) ? {display: "flex", flexGrow: 1, marginTop: 5, minWidth: 180}
                            : {display: "flex", flexGrow: 0, marginLeft: 10, backgroundColor: "red"}}>

                            { phoneNew ?
                                <div style={{display: "flex", flexGrow: 1, minWidth: 180}}>
                                  <InputMasked
                                    type="text"
                                    name="clientNewPhone"
                                    description="Telefone"
                                    mask="(999)999999999"
                                    value={phone}
                                    disabled={false}
                                    require={true}
                                    image={false}
                                    typeImage={0}
                                    typeInput={2}
                                    onSelect={setFieldSelected}
                                    onChange={(event) => setPhone(event.target.value)} />
                                </div>        
                              :
                                <div style={(width < 360) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                  : {display: "flex", flexDirection: "row", flexGrow: 1}}>
                                  <div style={{display: "flex", flexGrow: 1}}>
                                    <Select
                                      name="clientNewPhoneCode"
                                      description="Selecione o Telefone"
                                      value={phoneCode}
                                      disabled={false}
                                      require={false}
                                      options={JSON.parse(optionsPhone)}
                                      image={false}
                                      typeImage={0}
                                      typeInput={2}
                                      onSelect={setFieldSelected}
                                      set={selectPhone} 
                                    />
                                  </div>
                                  <div style={(width < 360) ? {display: "flex", flexGrow: 1, justifyContent: "center", marginTop: 5}
                                    : {display: "flex", flexGrow: 0, marginLeft: 10}}>
                                    <img
                                      style={{height: 42, width: 42, marginLeft: 10}}
                                      name="clientNewPhoneNew"
                                      src={image_add} 
                                      alt="Novo" 
                                      onClick={() => newPhone()} />
                                  </div>
                                </div>
                            }
                          </div>
                        </div>

                        <div style={(width < 380) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 5}
                          : (width < 910) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 5}
                          : {display: "flex", flexGrow: 0, marginLeft: 10}}>
                          <div style={(width < 380) ? {display: "flex", flexGrow: 1, minWidth: 180}
                            : (width < 910) ? {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 140}
                            : {display: "flex", flexGrow: 0, minWidth: 140, maxWidth: 140}}>
                            <Select
                              name="clientNewDiaVencimento"
                              description="Dia Vencto"
                              value={dueDay || 3}
                              disabled={false}
                              require={true}
                              options={JSON.parse("{ \"RESULT\": [{\"ID\": 1, \"VALUE\": \"1\" }"+
                                ", {\"ID\": 2, \"VALUE\": \"10\" }"+
                                ", {\"ID\": 3, \"VALUE\": \"20\" }] }")}
                              image={false}
                              typeImage={0}
                              typeInput={2}
                              onSelect={setFieldSelected}
                              set={setDueDay} />
                          </div>
                          <div style={(width < 380) ? {display: "flex", flexGrow: 1, marginTop: 5, minWidth: 180}
                            : (width < 910) ? {display: "flex", flexGrow: 1, flexBasis: 1, marginLeft: 10, minWidth: 180}
                            : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 180, maxWidth: 180}}>
                            <InputMasked
                              name="clientNewDateBirth"
                              description="Data Nascimento"
                              planceHolder=""
                              mask="99/99/9999"
                              value={dateBirth}
                              disabled={false}
                              require={false}
                              image={false}
                              typeImage={0}
                              typeInput={2}
                              onSelect={setFieldSelected}
                              onChange={(event) => setDateBirth(event.target.value)} />
                          </div>
                        </div>
                      </div> 

                      <div style={(width < 610) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 5}
                        : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 5}}>
                        <div style={(width < 610) ? {display: "flex", flexGrow: 1, minWidth: 180}
                          : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 220}}>
                          <Select
                            name="clientNewRegime"
                            description="Regime"
                            value={regime || 1}
                            require={true}
                            options={JSON.parse("{ \"RESULT\": [{\"ID\": 1, \"VALUE\": \"Simples\" }"+
                              ", {\"ID\": 2, \"VALUE\": \"Lucro Presumido\" }"+
                              ", {\"ID\": 3, \"VALUE\": \"Lucro Real\" }] }")}
                            image={false}
                            typeInput={2}
                            onSelect={setFieldSelected}
                            set={setRegime} />
                        </div>
                        <div style={(width < 610) ? {display: "flex", flexGrow: 1, minWidth: 180, marginTop: 5}
                          : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 280, marginLeft: 10}}>
                          <Select
                            name="clientNewRegimeSpecial"
                            description="Regime Especial"
                            value={regimeSpecial || 5}
                            require={true}
                            options={JSON.parse("{ \"RESULT\": [{\"ID\": 1, \"VALUE\": \"Microempresa Municipal\" }"+
                              ", {\"ID\": 2, \"VALUE\": \"Estimativa\" }"+
                              ", {\"ID\": 3, \"VALUE\": \"Sociedade de Profissionais\" }"+
                              ", {\"ID\": 4, \"VALUE\": \"Cooperativa\" }"+
                              ", {\"ID\": 5, \"VALUE\": \"MEI Simples Nacional\" }"+
                              ", {\"ID\": 6, \"VALUE\": \"ME EPP Simples Nacional\" }] }")}
                            image={false}
                            typeInput={2}
                            onSelect={setFieldSelected}
                            set={setRegimeSpecial} />
                        </div>
                      </div> 

                      <div style={(width < 560) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 5}
                        : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 5}}>
                        <div style={(width < 560) ? {display: "flex", flexGrow: 1, minWidth: 180}
                          : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 180}}>
                          <Input
                            type="password"
                            name="clientNewPassword"
                            description="Senha"
                            value={password}
                            maxLength={6}
                            disabled={false}
                            require={true}
                            image={false}
                            typeInput={2}
                            onSelect={setFieldSelected}
                            onChange={(event) => setPassword(event.target.value)} />
                        </div>
                        <div style={(width < 560) ? {display: "flex", flexGrow: 1, marginTop: 5, minWidth: 180}
                          : {display: "flex", flexGrow: 1, flexBasis: 1, marginLeft: 5, minWidth: 180}}>
                          <Input
                            type="password"
                            name="clientNewPasswordConfirm"
                            description="Confirme a Senha"
                            value={passwordConfirm}
                            maxLength={6}
                            disabled={false}
                            require={true}
                            image={false}
                            typeInput={2}
                            onSelect={setFieldSelected}
                            onChange={(event) => setPasswordConfirm(event.target.value)} />
                        </div>
                      </div> 
                          
                      <div style={(width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 10, minWidth: 180}
                        : {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 10, minWidth: 180}}>
                        <Titulo description="Endereço" />
                      </div>

                      <div style={(width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 0}
                        : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                        <div style={(width < 650) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                          : {display: "flex", flexDirection: "row", flexGrow: 1}}>
                          <div style={{display: "flex", flexGrow: 1}}>
                            <Select
                              name="clientNewCountryCode"
                              description="País"
                              value={countryCode || 0}
                              disabled={false}
                              require={false}
                              options={JSON.parse(optionsCountries)}
                              image={false}
                              typeImage={0}
                              typeInput={2}
                              onSelect={setFieldSelected}
                              set={selectCountry} 
                            />
                          </div>
                          <div style={(width < 650) ? {display: "flex", flexGrow: 1, marginTop: 5, minWidth: 180}
                            : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 140, maxWidth: 140}}>
                            <Input
                              type="text"
                              name="clientNewCep"
                              description="CEP"
                              value={cep}
                              maxLength={8}
                              disabled={false}
                              require={national ? true : false}
                              image={false}
                              typeImage={0}
                              typeInput={2}
                              onSelect={setFieldSelected}
                              onChange={(event) => setCep(event.target.value)} />
                          </div>
                        </div>

                        <div style={(width < 450) ? {display: "flex", flexDirection: "row", flexGrow: 1, justifyContent: "center", 
                          marginTop: 5}
                          : (width < 650) ? {display: "flex", flexDirection: "row", flexGrow: 0, alignItems: "end"}
                          : {display: "flex", flexDirection: "row", flexGrow: 0, alignItems: "end"}}>

                          { (national && (!addressRelease)) &&
                            <img
                              style={{height: 42, width: 42, marginLeft: 10}}
                              name="clientNewSearchAddress"
                              src={image_search} 
                              alt="Pesquisar" 
                              onClick={() => searchCEP()} />
                          }

                          <img
                            style={{height: 42, width: 42, marginLeft: 10}}
                            name="clientNewClearAddress"
                            src={image_clean} 
                            alt="Limpar" 
                            onClick={clearAddress} />
                        </div>
                      </div>

                      <div style={(width < 680) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 5}
                        : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 5}}>
                        <div style={{display: "flex", flexDirection: "row", flexGrow: 1, minWidth: 180}}>
                          <Input
                            type="text"
                            name="clientNewAddress"
                            description="Logradouro"
                            value={address}
                            maxLength={60}
                            disabled={(national && (!addressRelease)) ? true : false}
                            require={true}
                            image={false}
                            typeImage={0}
                            typeInput={2}
                            onSelect={setFieldSelected} 
                            onChange={(event) => setAddress(event.target.value)} />
                        </div>

                        <div style={(width < 400) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 5}
                          : (width < 680) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 5}
                          : {display: "flex", flexDirection: "row", flexGrow: 0, marginLeft: 10}}>
                          <div style={(width < 400) ? {display: "flex", flexDirection: "row", flexGrow: 1, minWidth: 180}
                            : {display: "flex", flexDirection: "row", flexGrow: 0, minWidth: 120, maxWidth: 120}}>
                            <Input
                              type="text"
                              name="clientNewNumber"
                              description="Número"
                              value={number}
                              maxLength={60}
                              disabled={false}
                              require={true}
                              image={false}
                              typeImage={0}
                              typeInput={2}
                              onSelect={setFieldSelected}
                              onChange={(event) => setNumber(event.target.value)} />
                          </div>
                          <div style={(width < 400) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 5, minWidth: 180}
                            : (width < 680) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 10, minWidth: 180}
                            : {display: "flex", flexDirection: "row", flexGrow: 0, marginLeft: 10, minWidth: 180, maxWidth: 180}}>
                            <Input
                              type="text"
                              name="clientNewComplement"
                              description="Complemento"
                              value={complement}
                              maxLength={60}
                              disabled={false}
                              require={false}
                              image={false}
                              typeImage={0}
                              typeInput={2}
                              onSelect={setFieldSelected}
                              onChange={(event) => setComplement(event.target.value)} />
                          </div>
                        </div>
                      </div>

                      <div style={(width < 650) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 5}
                        : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 5}}>
                        <div style={{display: "flex", flexDirection: "row", flexGrow: 1, flexBasis: 1, minWidth: 180}}>
                          <Input
                            type="text"
                            name="clientNewNeighborhood"
                            description="Bairro"
                            value={neighborhood}
                            maxLength={60}
                            disabled={(national && (!addressRelease)) ? true : false}
                            require={true}
                            image={false}
                            typeImage={0}
                            typeInput={2} 
                            onSelect={setFieldSelected} 
                            onChange={(event) => setNeighborhood(event.target.value)} />
                        </div>
                        <div style={(width < 650) ? {display: "flex", flexGrow: 1, marginTop: 5, minWidth: 180}
                          : {display: "flex", flexGrow: 1, flexBasis: 1, marginLeft: 10, minWidth: 180}}>
                          <Input
                            type="text"
                            name="clientNewCity"
                            description="Cidade"
                            value={city}
                            maxLength={60}
                            disabled={national ? true : false}
                            require={true}
                            image={false}
                            typeImage={0}
                            typeInput={2} 
                            onSelect={setFieldSelected} 
                            onChange={(event) => setCity(event.target.value)} />
                        </div>
                      </div>

                      <div style={(width < 650) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 5}
                        : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 5}}>

                        <div style={{display: "flex", flexDirection: "row", flexGrow: 1, flexBasis: 1, minWidth: 180}}>
                          <Input
                            type="text"
                            name="clientNewUf"
                            description="Estado"
                            value={uf}
                            maxLength={2}
                            disabled={(national && (!addressRelease)) ? true : false}
                            require={true}
                            image={false}
                            typeImage={0}
                            typeInput={2} 
                            onSelect={setFieldSelected} 
                            onChange={(event) => setUf(event.target.value)} />
                        </div>
                        <div style={(width < 650) ? {display: "flex", flexGrow: 1, marginTop: 5, minWidth: 180}
                          : {display: "flex", flexGrow: 1, flexBasis: 1, marginLeft: 10, minWidth: 180}}>                        
                          <Input
                            type="text"
                            name="clientNewCountryDescription"
                            description="País"
                            value={countryDescription}
                            maxLength={60}
                            disabled={true}
                            require={true}
                            image={false}
                            typeImage={0}
                            typeInput={2} 
                            onSelect={setFieldSelected} 
                            onChange={(event) => setCountryDescription(event.target.value)} />
                        </div>
                      </div>
                    </div>
                  :
                    <div style={(width < 450) ? {display: "flex", flexDirection: "column", paddingLeft: 10, paddingRight: 10}
                      : {display: "flex", flexDirection: "column", paddingLeft: 20, paddingRight: 20}}>

                      <div style={{display: "flex", justifyContent: "center", marginBottom: 10}}>
                        <label style={{fontWeight: 600, textAlign: "center"}}>Informe os dados da empresa:</label>
                      </div>

                      <div style={
                        (width < 680) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 10}
                        : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 10}}>
                        <div style={{display: "flex", flexGrow: 0, minWidth: 190}}>
                          <Input
                            type="text"
                            name="clientNewCpfCnpj"
                            description="CNPJ"
                            value={cpfCnpj}
                            maxLength={14}
                            disabled={true}
                            require={true}
                            image={false}
                            typeInput={2}
                            onSelect={setFieldSelected}
                            onChange={(event) => setCpfCnpj(event.target.value)} />
                        </div>

                        <div style={(width < 480) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 5}
                          : (width < 680) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 5}
                          : {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 10}}>
                          <div style={
                            (width < 480) ? {display: "flex", flexGrow: 1, marginTop: 5, minWidth: 180}
                            :  {display: "flex", flexGrow: 1, minWidth: 190}}>
                            <Select
                              name="clientNewSaleType"
                              description="Tipo da Venda"
                              value={saleType || 1}
                              disabled={false}
                              require={true}
                              options={JSON.parse("{ \"RESULT\": [{\"ID\": 1, \"VALUE\": \"Direta\" }"+
                                ", {\"ID\": 2, \"VALUE\": \"Pedido\" }"+
                                ", {\"ID\": 3, \"VALUE\": \"Restaurante\" }] }")}
                              image={false}
                              typeImage={0}
                              typeInput={2}
                              onSelect={setFieldSelected}
                              set={setSaleType} />
                          </div>
                          <div style={
                            (width < 480) ? {display: "flex", flexGrow: 1, marginTop: 5, minWidth: 180}
                            : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 140, maxWidth: 140}}>
                            <Select
                              name="clientNewDueDay"
                              description="Dia Vencto"
                              value={dueDay || 1}
                              disabled={false}
                              require={true}
                              options={JSON.parse("{ \"RESULT\": [{\"ID\": 1, \"VALUE\": \"1\" }"+
                                ", {\"ID\": 2, \"VALUE\": \"10\" }"+
                                ", {\"ID\": 3, \"VALUE\": \"20\" }] }")}
                              image={false}
                              typeImage={0}
                              typeInput={2}
                              onSelect={setFieldSelected}
                              set={setDueDay} />
                          </div>
                        </div>
                      </div>

                      <div style={(width < 760) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 5}
                        : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 5}}>
                        <div style={(width < 650) ? {display: "flex", flexGrow: 1, minWidth: 180}
                          : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 180}}>
                          <Input
                            type="text"
                            name="clientNewCorporateName"
                            description="Razão Social"
                            value={corporateName}
                            maxLength={60}
                            disabled={false}
                            require={true}
                            image={false}
                            typeInput={2}
                            onSelect={setFieldSelected}
                            onChange={(event) => setCorporateName(event.target.value)} />
                        </div>
                        <div style={(width < 760) ? {display: "flex", flexGrow: 1, minWidth: 180, marginTop: 5}
                          : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 180, marginLeft: 10}}>
                          <Input
                            type="text"
                            name="clientNewFantasyName"
                            description="Nome Fantasia"
                            value={fantasyName}
                            maxLength={60}
                            disabled={false}
                            require={false}
                            image={false}
                            typeInput={2}
                            onSelect={setFieldSelected}
                            onChange={(event) => setFantasyName(event.target.value)}  />
                        </div>
                      </div>

                      <div style={(width < 590) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 5}
                        : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 5}}>
                        <div style={(width < 590) ? {display: "flex", flexGrow: 1, minWidth: 180}
                          : {display: "flex", flexGrow: 0, minWidth: 180, maxWidth: 180}}>
                          <Input
                            type="text"
                            name="clientNewResponsibleCpf"
                            description="CPF Reponsável"
                            value={responsibleCpf}
                            maxLength={11}
                            disabled={false}
                            require={true}
                            image={false}
                            typeInput={2}
                            onSelect={setFieldSelected}
                            onChange={(event) => setResponsibleCpf(event.target.value)} />
                        </div>
                        <div style={(width < 590) ? {display: "flex", flexGrow: 1, marginTop: 5, minWidth: 180}
                          : {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 180}}>
                          <Input
                            type="text"
                            name="clientNewResponsibleName"
                            description="Nome Responsável"
                            value={responsibleName}
                            maxLength={60}
                            disabled={false}
                            require={true}
                            image={false}
                            typeInput={2}
                            onSelect={setFieldSelected}
                            onChange={(event) => setResponsibleName(event.target.value)} />
                        </div>
                      </div>

                      <div style={(width < 1070) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 5}
                        : {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 5}}>
                        <div style={(width < 540) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                          : {display: "flex", flexDirection: "row", flexGrow: 1}}>
                          <div style={(width < 540) ? {display: "flex", flexGrow: 1, minWidth: 180}
                            : {display: "flex", flexGrow: 0, minWidth: 190, maxWidth: 190}}>
                            <InputMasked
                              type="text"
                              name="clientNewIe"
                              description="IE"
                              mask="99999999999999"
                              value={ie}
                              disabled={false}
                              require={false}
                              image={false}
                              typeImage={0}
                              typeInput={2}
                              onSelect={setFieldSelected}
                              onChange={(event) => setIe(event.target.value)} />
                          </div>
                          <div style={(width < 540) ? {display: "flex", flexGrow: 1, marginTop: 5, minWidth: 180}
                            : {display: "flex", flexGrow: 1, marginLeft: 10, minWidth: 280}}>
                            <Select
                              name="clientNewIndicatorIe"
                              description="Indicador IE"
                              value={indicatorIe || 3}
                              disabled={false}
                              require={true}
                              options={JSON.parse("{ \"RESULT\": [{\"ID\": 1, \"VALUE\": \"Contribuinte do ICMS\" }"+
                                ", {\"ID\": 2, \"VALUE\": \"Contribuinte Isento de ICMS\" }"+
                                ", {\"ID\": 3, \"VALUE\": \"Não Contribuinte do ICMS\" }] }")}
                              image={false}
                              typeImage={0}
                              typeInput={2}
                              onSelect={setFieldSelected}
                              set={setIndicatorIe} />
                          </div>
                        </div>

                        <div style={(width < 570) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 5}
                          : (width < 1070) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 5}
                          : {display: "flex", flexDirection: "row", flexGrow: 0, marginLeft: 10}}>

                          <div style={{display: "flex", flexGrow: 1, minWidth: 200}}>
                            <Input
                              type="text"
                              name="clientNewIm"
                              description="IM"
                              value={im}
                              maxLength={15}
                              disabled={false}
                              require={false}
                              image={false}
                              typeImage={0}
                              typeInput={2}
                              onSelect={setFieldSelected}
                              onChange={(event) => setIm(event.target.value)} />
                          </div>

                          <div style={(width < 360) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 5}
                            : (width < 570) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 5}
                            : {display: "flex", flexDirection: "row", flexGrow: 0, marginLeft: 10}}>
                            <div style={(width < 360) ? {display: "flex", flexGrow: 1, minWidth: 180}
                              : (width < 570) ? {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 150}
                              : {display: "flex", flexGrow: 0, minWidth: 150, maxWidth: 150}}>
                              <Input
                                type="text"
                                name="clientNewCnae"
                                description="CNAE"
                                value={cnae}
                                maxLength={9}
                                disabled={false}
                                require={false}
                                image={false}
                                typeInput={2}
                                onSelect={setFieldSelected}
                                onChange={(event) => setCnae(event.target.value)} />
                            </div>

                            <div style={(width < 360) ? {display: "flex", flexGrow: 1, marginTop: 5, minWidth: 180}
                              : (width < 570) ? {display: "flex", flexGrow: 1, flexBasis: 1, marginLeft: 10, minWidth: 150}
                              : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 150, maxWidth: 150}}>
                              <Input
                                type="text"
                                name="clientNewSuframa"
                                description="SUFRAMA"
                                value={suframa}
                                maxLength={9}
                                disabled={false}
                                require={false}
                                image={false}
                                typeInput={2}
                                onSelect={setFieldSelected}
                                onChange={(event) => setSuframa(event.target.value)} />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div style={(width < 890) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 5}
                        : {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 5}}>

                        { emailNew ?
                            <div style={{display: "flex", flexGrow: 1, minWidth: 180}}>
                              <Input
                                type="text"
                                name="clientNewEmail"
                                description="Email"
                                value={email}
                                maxLength={70}
                                disabled={false}
                                require={true}
                                image={false}
                                typeInput={2}
                                onSelect={setFieldSelected}
                                onChange={(event) => setEmail(event.target.value)} />
                            </div>
                          :
                            <div style={(width < 510) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                              : {display: "flex", flexDirection: "row", flexGrow: 1}}>
                              <div style={{display: "flex", flexGrow: 1}}>
                                <Select
                                  name="clientNewEmailCode"
                                  description="Selecione o Email"
                                  value={emailCode}
                                  disabled={false}
                                  require={false}
                                  options={JSON.parse(optionsEmails)}
                                  image={false}
                                  typeImage={0}
                                  typeInput={2}
                                  onSelect={setFieldSelected}
                                  set={selectEmail} 
                                />
                              </div>                                
                              <div style={(width < 510) ? {display: "flex", flexGrow: 1, justifyContent: "center", marginTop: 5}
                                : {display: "flex", flexGrow: 0, alignItems: "end", marginLeft: 10}}>
                                <img
                                  style={{height: 42, width: 42}}
                                  name="clientNewEmailNew"
                                  src={image_add} 
                                  alt="Novo" 
                                  onClick={() => newEmail()} />                                  
                              </div>
                            </div>
                        }

                        <div style={(width < 890) ? {display: "flex", flexGrow: 1, marginTop: 5, minWidth: 180}
                          : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 250, maxWidth: 250}}>

                          { phoneNew ?
                              <div style={{display: "flex", flexGrow: 1, minWidth: 180}}>
                                <InputMasked
                                  type="text"
                                  name="clientNewPhone"
                                  description="Telefone"
                                  mask="(999)999999999"
                                  value={phone}
                                  disabled={false}
                                  require={true}
                                  image={false}
                                  typeImage={0}
                                  typeInput={2}
                                  onSelect={setFieldSelected}
                                  onChange={(event) => setPhone(event.target.value)} />
                              </div>        
                            :
                              <div style={(width < 360) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                                : {display: "flex", flexDirection: "row", flexGrow: 1}}>
                                <div style={{display: "flex", flexGrow: 1}}>
                                  <Select
                                    name="clientNewPhoneCode"
                                    description="Selecione o Telefone"
                                    value={phoneCode}
                                    disabled={false}
                                    require={false}
                                    options={JSON.parse(optionsPhone)}
                                    image={false}
                                    typeImage={0}
                                    typeInput={2}
                                    onSelect={setFieldSelected}
                                    set={selectPhone} 
                                  />
                                </div>
                                <div style={(width < 360) ? {display: "flex", flexGrow: 1, justifyContent: "center", marginTop: 5}
                                  : {display: "flex", flexGrow: 0, alignItems: "end", marginLeft: 10}}>
                                  <img
                                    style={{height: 42, width: 42}}
                                    name="clientNewPhoneNew"
                                    src={image_add} 
                                    alt="Novo" 
                                    onClick={() => newPhone()} />
                                </div>
                              </div>
                          }
                        </div>
                      </div>

                      <div style={(width < 610) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 5}
                        : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 5}}>
                        <div style={(width < 610) ? {display: "flex", flexGrow: 1, minWidth: 180}
                          : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 220}}>
                          <Select
                            name="clientNewRegime"
                            description="Regime"
                            value={regime || 1}
                            require={true}
                            options={JSON.parse("{ \"RESULT\": [{\"ID\": 1, \"VALUE\": \"Simples\" }"+
                              ", {\"ID\": 2, \"VALUE\": \"Lucro Presumido\" }"+
                              ", {\"ID\": 3, \"VALUE\": \"Lucro Real\" }] }")}
                            image={false}
                            typeInput={2}
                            onSelect={setFieldSelected}
                            set={setRegime} />
                        </div>
                        <div style={(width < 610) ? {display: "flex", flexGrow: 1, minWidth: 180, marginTop: 5}
                          : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 280, marginLeft: 10}}>
                          <Select
                            name="clientNewRegimeSpecial"
                            description="Regime Especial"
                            value={regimeSpecial || 6}
                            require={true}
                            options={JSON.parse("{ \"RESULT\": [{\"ID\": 1, \"VALUE\": \"Microempresa Municipal\" }"+
                              ", {\"ID\": 2, \"VALUE\": \"Estimativa\" }"+
                              ", {\"ID\": 3, \"VALUE\": \"Sociedade de Profissionais\" }"+
                              ", {\"ID\": 4, \"VALUE\": \"Cooperativa\" }"+
                              ", {\"ID\": 5, \"VALUE\": \"MEI Simples Nacional\" }"+
                              ", {\"ID\": 6, \"VALUE\": \"ME EPP Simples Nacional\" }] }")}
                            image={false}
                            typeInput={2}
                            onSelect={setFieldSelected}
                            set={setRegimeSpecial} />
                        </div>
                      </div> 

                      <div style={(width < 560) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 5}
                        : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 5}}>
                        <div style={(width < 560) ? {display: "flex", flexGrow: 1, minWidth: 180}
                          : {display: "flex", flexGrow: 1, flexBasis: 1, minWidth: 180}}>
                          <Input
                            type="password"
                            name="clientNewPassword"
                            description="Senha"
                            value={password}
                            maxLength={6}
                            disabled={false}
                            require={true}
                            image={false}
                            typeInput={2}
                            onSelect={setFieldSelected}
                            onChange={(event) => setPassword(event.target.value)} />
                        </div>
                        <div style={
                          (width < 560) ? {display: "flex", flexGrow: 1, marginTop: 5, minWidth: 180}
                          : {display: "flex", flexGrow: 1, flexBasis: 1, marginLeft: 5, minWidth: 180}}>
                          <Input
                            type="password"
                            name="clientNewPasswordConfirm"
                            description="Confirme a Senha"
                            value={passwordConfirm}
                            maxLength={6}
                            disabled={false}
                            require={true}
                            image={false}
                            typeInput={2}
                            onSelect={setFieldSelected}
                            onChange={(event) => setPasswordConfirm(event.target.value)} />
                        </div>
                      </div>

                      <div style={
                        (width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 10, minWidth: 180}
                        : {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 10, minWidth: 180}}>
                        <Titulo description="Endereço" />
                      </div>

                      <div style={
                        (width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 0}
                        : {display: "flex", flexDirection: "row", flexGrow: 0}}>

                        <div style={(width < 650) ? {display: "flex", flexDirection: "column", flexGrow: 1}
                          : {display: "flex", flexDirection: "row", flexGrow: 1}}>
                          <div style={{display: "flex", flexGrow: 1}}>
                            <Select
                              name="clientNewCountryCode"
                              description="País"
                              value={countryCode || 0}
                              disabled={false}
                              require={false}
                              options={JSON.parse(optionsCountries)}
                              image={false}
                              typeImage={0}
                              typeInput={2}
                              onSelect={setFieldSelected}
                              set={selectCountry} />
                          </div>
                          <div style={(width < 650) ? {display: "flex", flexGrow: 1, marginTop: 5, minWidth: 180}
                            : {display: "flex", flexGrow: 0, marginLeft: 10, minWidth: 140, maxWidth: 140}}>
                            <Input
                              type="text"
                              name="clientNewCep"
                              description="CEP"
                              value={cep}
                              maxLength={8}
                              disabled={false}
                              require={national ? true : false}
                              image={false}
                              typeImage={0}
                              typeInput={2}
                              onSelect={setFieldSelected}
                              onChange={(event) => setCep(event.target.value)} />
                          </div>
                        </div>

                        <div style={(width < 450) ? {display: "flex", flexDirection: "row", flexGrow: 1, justifyContent: "center", 
                          marginTop: 5}
                          : (width < 650) ? {display: "flex", flexDirection: "row", flexGrow: 0, alignItems: "end"}
                          : {display: "flex", flexDirection: "row", flexGrow: 0, alignItems: "end"}}>

                          { (national && (!addressRelease)) &&
                            <img
                              style={{height: 42, width: 42, marginLeft: 10}}
                              name="clientNewSearchAddress"
                              src={image_search} 
                              alt="Pesquisar" 
                              onClick={() => searchCEP()} />
                          }

                          <img
                            style={{height: 42, width: 42, marginLeft: 10}}
                            name="clientNewClearAddress"
                            src={image_clean} 
                            alt="Limpar" 
                            onClick={clearAddress} />
                        </div>
                      </div>

                      <div style={(width < 680) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 5}
                        : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 5}}>
                        <div style={{display: "flex", flexDirection: "row", flexGrow: 1, minWidth: 180}}>
                          <Input
                            type="text"
                            name="clientNewAddress"
                            description="Logradouro"
                            value={address}
                            maxLength={60}
                            disabled={(national && (!addressRelease)) ? true : false}
                            require={true}
                            image={false}
                            typeImage={0}
                            typeInput={2}
                            onSelect={setFieldSelected} 
                            onChange={(event) => setAddress(event.target.value)} />
                        </div>

                        <div style={(width < 400) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 5}
                          : (width < 680) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 5}
                          : {display: "flex", flexDirection: "row", flexGrow: 0, marginLeft: 10}}>
                          <div style={(width < 400) ? {display: "flex", flexDirection: "row", flexGrow: 1, minWidth: 180}
                            : {display: "flex", flexDirection: "row", flexGrow: 0, minWidth: 120, maxWidth: 120}}>
                            <Input
                              type="text"
                              name="clientNewNumber"
                              description="Número"
                              value={number}
                              maxLength={60}
                              disabled={false}
                              require={true}
                              image={false}
                              typeImage={0}
                              typeInput={2}
                              onSelect={setFieldSelected}
                              onChange={(event) => setNumber(event.target.value)} />
                          </div>
                          <div style={(width < 400) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginTop: 5, minWidth: 180}
                            : (width < 680) ? {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 10, minWidth: 180}
                            : {display: "flex", flexDirection: "row", flexGrow: 0, marginLeft: 10, minWidth: 180, maxWidth: 180}}>
                            <Input
                              type="text"
                              name="clientNewComplement"
                              description="Complemento"
                              value={complement}
                              maxLength={60}
                              disabled={false}
                              require={false}
                              image={false}
                              typeImage={0}
                              typeInput={2}
                              onSelect={setFieldSelected}
                              onChange={(event) => setComplement(event.target.value)} />
                          </div>
                        </div>
                      </div>

                      <div style={(width < 650) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 5}
                        : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 5}}>

                        <div style={{display: "flex", flexDirection: "row", flexGrow: 1, flexBasis: 1, minWidth: 180}}>
                          <Input
                            type="text"
                            name="clientNewNeighborhood"
                            description="Bairro"
                            value={neighborhood}
                            maxLength={60}
                            disabled={(national && (!addressRelease)) ? true : false}
                            require={true}
                            image={false}
                            typeImage={0}
                            typeInput={2} 
                            onSelect={setFieldSelected} 
                            onChange={(event) => setNeighborhood(event.target.value)} />
                        </div>
                        <div style={(width < 650) ? {display: "flex", flexGrow: 1, marginTop: 5, minWidth: 180}
                          : {display: "flex", flexGrow: 1, flexBasis: 1, marginLeft: 10, minWidth: 180}}>
                          <Input
                            type="text"
                            name="clientNewCity"
                            description="Cidade"
                            value={city}
                            maxLength={60}
                            disabled={national ? true : false}
                            require={true}
                            image={false}
                            typeImage={0}
                            typeInput={2} 
                            onSelect={setFieldSelected} 
                            onChange={(event) => setCity(event.target.value)} />
                        </div>
                      </div>

                      <div style={(width < 650) ? {display: "flex", flexDirection: "column", flexGrow: 0, marginTop: 5}
                        : {display: "flex", flexDirection: "row", flexGrow: 0, marginTop: 5}}>
                        <div style={{display: "flex", flexDirection: "row", flexGrow: 1, flexBasis: 1, minWidth: 180}}>
                          <Input
                            type="text"
                            name="clientNewUf"
                            description="Estado"
                            value={uf}
                            maxLength={2}
                            disabled={(national && (!addressRelease)) ? true : false}
                            require={true}
                            image={false}
                            typeImage={0}
                            typeInput={2} 
                            onSelect={setFieldSelected} 
                            onChange={(event) => setUf(event.target.value)} />
                        </div>
                        <div style={(width < 650) ? {display: "flex", flexGrow: 1, marginTop: 5, minWidth: 180}
                          : {display: "flex", flexGrow: 1, flexBasis: 1, marginLeft: 10, minWidth: 180}}>
                          <Input
                            type="text"
                            name="clientNewCountryDescription"
                            description="País"
                            value={countryDescription}
                            maxLength={60}
                            disabled={true}
                            require={true}
                            image={false}
                            typeImage={0}
                            typeInput={2} 
                            onSelect={setFieldSelected} 
                            onChange={(event) => setCountryDescription(event.target.value)} />
                        </div>
                      </div>                      
                    </div>
                  }

                  <div style={{display: "flex", flexDirection: "row", flexGrow: 0, flexWrap: "wrap", justifyContent: "center", 
                    marginTop: 10}}>
                    <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, 
                      marginTop: 10, marginLeft: 5, width: 147}} onClick={() => saveClient()}>
                      <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                        paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                        <img style={{height: 32, width: 32}} src={image_save} alt="Salvar"/>
                      </div>
                      <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                        <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Salvar</label>
                      </div>
                    </div>

                    <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, 
                      marginTop: 10, marginLeft: 5, width: 147}} onClick={() => returnClientNew()}>
                      <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                        paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                        <img style={{height: 32, width: 32}} src={image_previous} alt="Retornar"/>
                      </div>
                      <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                        <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Retornar</label>
                      </div>
                    </div>
                  </div>
                </>
              }

              { emailValidation &&
                <>


                  <div style={{display: "flex", flexDirection: "row", flexGrow: 0, flexWrap: "wrap", justifyContent: "center", 
                    marginTop: 10}}>
                    <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, 
                      marginTop: 10, marginLeft: 5, width: 147}} onClick={() => validationEmail()}>
                      <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                        paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                        <img style={{height: 32, width: 32}} src={image_save} alt="Verificar"/>
                      </div>
                      <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                        <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Salvar</label>
                      </div>
                    </div>

                    <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, 
                      marginTop: 10, marginLeft: 5, width: 147}} onClick={() => resendEmail()}>
                      <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                        paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                        <img style={{height: 32, width: 32}} src={image_save} alt="Re-Enviar"/>
                      </div>
                      <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                        <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Re-Enviar</label>
                      </div>
                    </div>                    

                    <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, 
                      marginTop: 10, marginLeft: 5, width: 147}} onClick={() => returnEmail()}>
                      <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                        paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                        <img style={{height: 32, width: 32}} src={image_previous} alt="Retornar"/>
                      </div>
                      <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                        <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Retornar</label>
                      </div>
                    </div>
                  </div>
                </>
              }

              { phoneValidation &&
                <>


                  <div style={{display: "flex", flexDirection: "row", flexGrow: 0, flexWrap: "wrap", justifyContent: "center", 
                    marginTop: 10}}>
                    <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, 
                      marginTop: 10, marginLeft: 5, width: 147}} onClick={() => validationPhone()}>
                      <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                        paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                        <img style={{height: 32, width: 32}} src={image_save} alt="Verificar"/>
                      </div>
                      <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                        <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Salvar</label>
                      </div>
                    </div>

                    <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, 
                      marginTop: 10, marginLeft: 5, width: 147}} onClick={() => resendPhone()}>
                      <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                        paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                        <img style={{height: 32, width: 32}} src={image_save} alt="Re-Enviar"/>
                      </div>
                      <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                        <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Re-Enviar</label>
                      </div>
                    </div>                    

                    <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, 
                      marginTop: 10, marginLeft: 5, width: 147}} onClick={() => returnPhone()}>
                      <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                        paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                        <img style={{height: 32, width: 32}} src={image_previous} alt="Retornar"/>
                      </div>
                      <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                        <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Retornar</label>
                      </div>
                    </div>
                  </div>                
                </>
              }

              { databaseScreen &&
                <>


                  <div style={{display: "flex", flexDirection: "row", backgroundColor: "rgb(241, 242, 242)", borderRadius: 5, 
                    marginTop: 10, marginLeft: 5, width: 147}} onClick={() => returnClientNew()}>
                    <div style={{display: "flex", flexGrow: 0, alignItems: "center", justifyContent: "center", paddingTop: 5, 
                      paddingRight: 10, paddingBottom: 5, paddingLeft: 10}}>
                      <img style={{height: 32, width: 32}} src={image_previous} alt="Retornar"/>
                    </div>
                    <div style={{display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center"}}>
                      <label style={{fontWeight: 600, paddingLeft: 10, paddingRight: 10}}>Retornar</label>
                    </div>
                  </div>
                </>
              }

              <div style={{display: "flex", flexGrow: 0, flexDirection: "row", paddingRight: 10, paddingLeft: 10, marginTop: 10}}>
                { warning && 
                  <div style={{display: "flex", flexGrow: 1, flexDirection: "row", justifyContent: "center", marginTop: 10,
                    marginBottom: 10}}>
                    <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>{warning}</label>
                  </div>
                }

                { error &&
                  <div style={{display: "flex", flexGrow: 1, flexDirection: "row", justifyContent: "center", marginTop: 10,
                    marginBottom: 10}}>
                    <label style={{fontWeight: 600, color: "red"}}>{error}</label>
                  </div>
                }
              </div>
            </>
      }
    </div>
  )
}

export default ClientNew